import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  trend?: 'up' | 'down' | 'neutral';
  icon: BoxIcon;
  color: string; // Tailwind color class like 'bg-blue-500'
  isStatic?: boolean; // If true, removes hover effects and cursor pointer
}
export function StatCard({
  title,
  value,
  change,
  changeType,
  trend,
  icon: Icon,
  color,
  isStatic = false
}: StatCardProps) {
  // Extract color name for text coloring (e.g. 'bg-blue-500' -> 'text-blue-600')
  const colorName = color.replace('bg-', '').split('-')[0];
  // Map trend to changeType if changeType not provided
  const resolvedChangeType = changeType || (trend === 'up' ? 'positive' : trend === 'down' ? 'negative' : 'neutral');
  return <div className={`bg-white rounded-2xl p-6 shadow-sm border border-slate-100 relative overflow-hidden ${isStatic ? '' : 'hover:shadow-md transition-shadow group cursor-pointer'}`} data-id="element-1178">
      {!isStatic && <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-white/0 to-slate-50 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110`} data-id="element-1179"></div>}
      {isStatic && <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-white/0 to-slate-50 rounded-bl-full -mr-4 -mt-4`} data-id="element-1180"></div>}

      <div className="relative z-10" data-id="element-1181">
        <div className="flex justify-between items-start mb-4" data-id="element-1182">
          <div className={`p-3 rounded-xl ${color} bg-opacity-10 text-${colorName}-600`} data-id="element-1183">
            <Icon className="h-6 w-6" data-id="element-1184" />
          </div>
          {change && <span className={`
              inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
              ${resolvedChangeType === 'positive' ? 'bg-green-100 text-green-800' : resolvedChangeType === 'negative' ? 'bg-red-100 text-red-800' : 'bg-slate-100 text-slate-800'}
            `} data-id="element-1185">
              {change}
            </span>}
        </div>

        <h3 className="text-slate-500 text-sm font-medium" data-id="element-1186">{title}</h3>
        <p className="text-2xl font-bold text-seform-navy mt-1" data-id="element-1187">{value}</p>
      </div>
    </div>;
}